import {
  AccountTypeEnum,
  ExternalPlaidAccount,
  InternalAdvanceAccount,
} from '@varo/graphql-schema-types';

const isRecord = (value: unknown): value is Record<string, unknown> =>
  !!value && typeof value === 'object';

/**
 * Type guard for external accounts linked via Plaid.
 */
export const isExternalPlaidAccount = (
  account: unknown,
): account is ExternalPlaidAccount =>
  isRecord(account) &&
  account.type === AccountTypeEnum.External &&
  'isCraEnabled' in account;

export const isInternalAdvanceAccount = (
  account: unknown,
): account is InternalAdvanceAccount =>
  isRecord(account) && 'pastAdvances' in account;
